<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-6 mb-2"
            type="text"
            labelColsSm="4"
            labelColsLg="4"
            :value="form.code"
            :disabled="!formEditable"
            @change="$set(form, 'code', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-6 mb-2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.description"
            :external-errors="errors['description']"
            :label-form="'Description' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.description"
            :disabled="!formEditable"
            @change="$set(form, 'description', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.phone"
            :external-errors="errors['phone']"
            :label-form="'Phone' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.phone"
            :disabled="!formEditable"
            @change="$set(form, 'phone', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.fax"
            :external-errors="errors['fax']"
            :label-form="'Fax' | translate"
            class-form="col-12 mb-2"
            type="text"
            :value="form.fax"
            :disabled="!formEditable"
            @change="$set(form, 'fax', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.email"
            :external-errors="errors['email']"
            :label-form="'Email' | translate"
            class-form="col-12 mb-2"
            type="email"
            :value="form.email"
            :disabled="!formEditable"
            @change="$set(form, 'email', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as OFFICE_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'OfficeEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Office',
      rolePerm: 'office_office_retrieve',
      editRolePerm: 'office_office_update'
    }
  },
  computed: {
    ...mapGetters({
      ...OFFICE_TYPES.GENERIC.office.office.DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...OFFICE_TYPES.GENERIC.office.office.DETAIL.ACTIONS
    })
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      description: {},
      phone: { required },
      fax: { required },
      email: {}
    }
  }
}
</script>
